module.exports = __webpack_public_path__ + "media/Video 95.695edb35.mp4";